import {Base} from "@/api/Base"

export class ServiceProviderListAll extends Base {
    path = "serviceProvider/listAll"
}